import React from 'react';
import { Container, Stack } from '@mui/material';
import i18next from 'i18next';
import i18n from 'Lang/i18n';
import EditableCustomizableSelect from 'Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import useGetLanguages from 'Global/Hooks/useGetLanguages';
import useInitialData from './useInitialData';

const LanguageSelector = ({ onChange = () => {} }) => {
  const [selectedValue, GetSelectedValue] = React.useState(
    {}
  );
  const languageSelector_msg = FindLangKey(
    'general-public-setting-language'
  );
  const languages = useGetLanguages(true);

  const initialData = useInitialData(languages);

  React.useEffect(() => {
    selectedValue?.ItemValue &&
      localStorage.setItem(
        'UserLanguage',
        JSON.stringify(
          selectedValue?.ItemValue?.split('-')[0]
        )
      );
    selectedValue?.ItemValue &&
      localStorage.setItem(
        'languageSelector',
        JSON.stringify(selectedValue?.ItemValue)
      );
    if (selectedValue?.ItemValue) {
      i18n.changeLanguage(
        selectedValue?.ItemValue?.split('-')[0]
      );
      if (
        selectedValue?.ItemValue?.split('-')[0] === 'en'
      ) {
        document.documentElement.style.setProperty(
          '--font-family',
          'Roboto'
        );
      } else {
        if (
          selectedValue?.ItemValue?.split('-')[0] === 'fa'
        ) {
          document.documentElement.style.setProperty(
            '--font-family',
            'IranYekan'
          );
        }
        if (
          selectedValue?.ItemValue?.split('-')[0] === 'ar'
        ) {
          document.documentElement.style.setProperty(
            '--font-family',
            'IranYekan'
          );
        }
      }
    }
  }, [selectedValue]);

  return (
    <React.Fragment>
      <Stack sx={{ mt: '.5em', p: 0 }}>
        <EditableCustomizableSelect
          onChange={onChange}
          isSmall={true}
          SelectableDataArray={languages}
          label={languageSelector_msg}
          isSingle={true}
          isEnglish={i18next.language === 'en'}
          GetSelectedValue={GetSelectedValue}
          initialData={[
            {
              ItemContent: initialData[0]?.ItemContent,
              ItemValue: initialData[0]?.ItemContent,
            },
          ]}
        />
      </Stack>
    </React.Fragment>
  );
};

export default LanguageSelector;
